import { render } from "./Claim.vue?vue&type=template&id=7bf330b2&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"

import "./Claim.vue?vue&type=style&index=0&id=7bf330b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf330b2"]])

export default __exports__